export default __webpack_public_path__ + "static/media/zgzsbh.b6106a3f.jpg";